export default __webpack_public_path__ + "static/media/icon-warning.b7fc3bb5.svg";